import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = ['item', 'input'];

  static values = {
    frameId: String,
    modalUrl: String,
  };

  search = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    this.itemTargets.forEach((item) => {
      item.hidden = !item.textContent.toLowerCase().includes(searchTerm);
    });
  };

  select = (element) => {
    const currentURL = new URL(window.location.href);
    const modalURL = new URL(this.modalUrlValue);

    currentURL.searchParams.forEach((value, key) => {
      modalURL.searchParams.append(key, value);
    });

    modalURL.searchParams.set(element.target.name, element.target.value);
    modalURL.searchParams.set('frame', this.frameIdValue);

    Turbo.visit(modalURL, { frame: this.frameIdValue });
  };

  apply = () => {
    const url = new URL(window.location.href);

    this.inputTargets.forEach((checkbox) => {
      url.searchParams.delete(checkbox.name);
    });

    this.inputTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        url.searchParams.append(checkbox.name, checkbox.value);
      }
    });

    this.close();
    Turbo.visit(url);
  };

  close() {
    // Remove src from frame so that it is not loaded again when the page is
    // restored from cache:
    const frame = this.element.parentElement;
    frame.removeAttribute('src');

    // Remove all content:
    this.element.remove();
  }
}
